import type { Schema } from "@/shared/components/Form/types";
import { OrganizationsAutocompleteQuery } from "@/admin/entities/organizations";
import { PlatformsAutocompleteQuery } from "@/admin/entities/platforms";

export const filterSchema: Schema = {
  status: {
    label: "Статус",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: [
      { label: "Все статусы", value: "" },
      { label: "Ожидает оплаты", value: "PENDING" },
      { label: "Оплачен", value: "SUCCEEDED" },
      { label: "Отменён", value: "CANCELED" },
      { label: "Возвращён", value: "REFUNDED" },
    ],
  },
  provider: {
    label: "Провайдер",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: [
      { label: "Все провайдеры", value: "" },
      { label: "STRIPE", value: "STRIPE" },
      { label: "PAYNET", value: "PAYNET" },
      { label: "CCBILL", value: "CCBILL" },
    ],
  },
  organizationId: {
    label: "Организация",
    type: "autocomplete",
    query: OrganizationsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
  platformId: {
    label: "Платформа",
    type: "autocomplete",
    query: PlatformsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
};
